import { Div } from '$gstyles';
import styled from '@emotion/styled';

export const BankWrapper = styled(Div)`
  .form-section {
    padding: 16px;
    background-color: #f6f6f6;
    margin: 8px;
    border-radius: 5px;
  }
`;
